module.exports = __webpack_public_path__ + "static/img/banner-global.25d3efc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/banner-global.png
// module id = nau2
// module chunks = 34